import type {
  GetMobileDevicesRequestParameters,
  MobileDevices,
} from "@/common/types/mobileDevices";
import axiosClient from "@/lib/axios/axiosClient";

export const getMobileDevices = async (
  parameters: GetMobileDevicesRequestParameters
): Promise<MobileDevices[]> => {
  const response = await axiosClient.get<MobileDevices[]>(
    `/users/${parameters.userId}/mobile-devices`,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};
